import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { addSeason } from '../../../../actions/ticketing/seasonsActions'
import SeasonForm from '../../../../components/forms/seasons/SeasonForm'

export default function AddSeason({usertype}) {
  	const { t } = useTranslation()
	const dispatch = useDispatch()
    const navigate = useNavigate()

	const {result, loading} = useSelector(state=>state.seasons)
	const {club} = useSelector(state=>state.clubs)

    const [newSeason, setNewSeason] = useState({
        name: '',
        startDate: '',
        endDate: ''
    })

    const handleInputChange = ({target})=>{
        setNewSeason({
            ...newSeason,
            [target.name]: target.value
        })
    }

    const handleAdd = async(e) => {
        e.preventDefault()

        if(newSeason.name !== ''){
            dispatch(addSeason({...newSeason, club: club._id}))
        }else{
            Swal.fire({
                showConfirmButton: true,
                showDenyButton: false,
                confirmButtonText: t('global.ok'),
                icon: 'warning',
                text: t('seasons.noName')
            })
        }
    }

    useEffect(() => {
        if(result){
            let newresult = result
            dispatch({
                type: 'SEASON_RESET_RESULT'
            })
            switch (newresult) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('seasons.addSuccess')
                    }).then(() => {
                        if(usertype === 'superadmin'){
                            navigate(`/${t("url.admin.admin")}/${t("url.admin.club")}/${t("url.admin.seasons")}`)
                        }else{
                            navigate(`/${t("url.club.club")}/${t("url.club.seasons")}`)
                        }
                    })
                    break;
                case 'duplicateName':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.ok'),
                        icon: 'warning',
                        text: t('seasons.duplicateName')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [result])

	return (
        <Container className='cuerpo'>
            <Row className="my-3">
                <Col>
                    <h1 className='ms-2 my-0'>{t('seasons.createNewSeason')}</h1>
                </Col>
            </Row>
            <Row className="my-3">
                <Col>
                    <Card>
                        <Card.Body>
                            <SeasonForm state={newSeason} statetype={'add'} usertype={usertype} isAdding={loading} submit={handleAdd} inputChange={handleInputChange}/>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
	)
}